import moment from 'moment-timezone';

interface TransformEventsParams<T> {
  events: T[];
  enabled: boolean;
  primaryTimezone?: string;
}

export const transformEventsForPrimaryTimezone = <
  T extends {
    start: Date | string;
    end: Date | string;
  }
>({
  events,
  enabled,
  primaryTimezone,
}: TransformEventsParams<T>): T[] => {
  if (!enabled || !primaryTimezone) {
    return events;
  }

  return events.map((event) => {
    const primaryStart = moment.tz(event.start, primaryTimezone);
    const primaryEnd = moment.tz(event.end, primaryTimezone);

    return {
      ...event,
      start: moment()
        .year(primaryStart.year())
        .month(primaryStart.month())
        .date(primaryStart.date())
        .hour(primaryStart.hour())
        .minute(primaryStart.minute())
        .second(0)
        .millisecond(0)
        .toDate(),
      end: moment()
        .year(primaryEnd.year())
        .month(primaryEnd.month())
        .date(primaryEnd.date())
        .hour(primaryEnd.hour())
        .minute(primaryEnd.minute())
        .second(0)
        .millisecond(0)
        .toDate(),
    };
  });
};

interface CalendarNowParams {
  enabled: boolean;
  primaryTimezone?: string;
}

export const getCalendarNow = ({ enabled, primaryTimezone }: CalendarNowParams): Date => {
  if (!enabled || !primaryTimezone) {
    return new Date();
  }

  const primaryNow = moment.tz(primaryTimezone);

  return new Date(
    primaryNow.year(),
    primaryNow.month(),
    primaryNow.date(),
    primaryNow.hours(),
    primaryNow.minutes(),
    primaryNow.seconds(),
    0,
  );
};

export const getDefaultScrollTime = ({ enabled, primaryTimezone }: CalendarNowParams): Date => {
  if (!enabled || !primaryTimezone) {
    return moment().startOf('day').hour(8).minute(0).toDate();
  }

  const primaryNow = moment.tz(primaryTimezone);

  return new Date(primaryNow.year(), primaryNow.month(), primaryNow.date(), 8, 0, 0, 0);
};
